/**
 * AUTO-GENERATED FILE. Do not edit directly.
 * Generated by scripts/generateBlogMapping.js
 * Source: landing_v2/blogs/*.html (meta tags: event-name, event-pattern, blog-title)
 */

const BLOG_MAPPING = {
  "BASE EVENT NAME": {
    "blogUrl": "/blogs/your-blog-file.html",
    "blogTitle": "Card headline shown on / and /blogs/",
    "type": "pattern"
  },
  "Alchemy of Fusion": {
    "blogUrl": "/blogs/fusion-alembic-2025-07-18.html",
    "blogTitle": "Fusion dance experience at Alembic",
    "type": "pattern"
  },
  "BAmF - Bay Area micro Fusion": {
    "blogUrl": "/blogs/fusion-bamf-emeryville-2025-08-09.html",
    "blogTitle": "Bay Area Micro Fusion experience",
    "type": "pattern"
  },
  "Mission Fusion": {
    "blogUrl": "/blogs/fusion-sf-missionfusion-2025-12-06.html",
    "blogTitle": "Mission Fusion at St. Gregory of Nyssa in San Francisco",
    "type": "pattern"
  },
  "Nested Micro": {
    "blogUrl": "/blogs/nestedmicro-byc-berkeley-2026-02-27.html",
    "blogTitle": "Nested Micro",
    "type": "pattern"
  },
  "Sunday Latin Bootcamp": {
    "blogUrl": "/blogs/salsa-latin-bootcamp-2025-10-05.html",
    "blogTitle": "Sunday Latin Bootcamp with Lorans, Latin Jam",
    "type": "pattern"
  },
  "Sausalito Seahorse Salsa Sunday": {
    "blogUrl": "/blogs/salsa-sausalito-seahorse-2025-10-12.html",
    "blogTitle": "Sausalito Seahorse Salsa Sunday",
    "type": "pattern"
  },
  "SJ Fusion": {
    "blogUrl": "/blogs/sj-fusion-dance-boulevard-2025-08-24.html",
    "blogTitle": "San Jose Fusion at Dance Boulevard",
    "type": "pattern"
  },
  "Ashkenaz Live Music Milonga": {
    "blogUrl": "/blogs/tango-ashkenaz-berkeley-2026-03-19.html",
    "blogTitle": "Ashkenaz Live Music Milonga",
    "type": "pattern"
  },
  "The Beat w/ Felipe & Ayano": {
    "blogUrl": "/blogs/tango-beat-2025-08-25.html",
    "blogTitle": "Tango at The Beat with Felipe & Ayano",
    "type": "pattern"
  },
  "All Night Milonga": {
    "blogUrl": "/blogs/tango-beat-berkeley-2025-12-31.html",
    "blogTitle": "All Night Milonga",
    "type": "pattern"
  },
  "Free flat-shoe practica @ Hillside Club": {
    "blogUrl": "/blogs/tango-berkeley-practica-2025-12-03.html",
    "blogTitle": "Free flat-shoe tango practica",
    "type": "pattern"
  },
  "CELLSpace Revival Alternative Milonga": {
    "blogUrl": "/blogs/tango-cellspace-oakland-2026-05-08.html",
    "blogTitle": "CELLSpace Revival Alternative Milonga",
    "type": "pattern"
  },
  "Empanada Milonga": {
    "blogUrl": "/blogs/tango-empanadamilonga-berkeley-2026-05-10.html",
    "blogTitle": "Empanada Milonga",
    "type": "pattern"
  },
  "Milonga Rubia w/ DJ": {
    "blogUrl": "/blogs/tango-milonga-rubia-2025-09-07.html",
    "blogTitle": "Milonga Rubia w/ DJ Ayano — Big Floor, Friendly Regulars, and BYOB",
    "type": "pattern"
  },
  "Spire Tango Practica (alt/contemporary)": {
    "blogUrl": "/blogs/tango-oakland-practica-2025-12-27.html",
    "blogTitle": "Spire Tango Practica (alt/contemporary) at Spire The Church in Oakland",
    "type": "pattern"
  },
  "Tea & Tango, Palo Alto": {
    "blogUrl": "/blogs/tango-paloalto-milonga-2025-11-22.html",
    "blogTitle": "Thanksgiving Milonga at Tea & Tango (Feeling Flow) in Palo Alto",
    "type": "pattern"
  },
  "Afternoon Practilonga - La Cadencia Tango": {
    "blogUrl": "/blogs/tango-redwoodcity-practilonga-2025-11-30.html",
    "blogTitle": "Afternoon Practilonga with La Cadencia Tango in Redwood City",
    "type": "pattern"
  },
  "Tango at Salesforce Park": {
    "blogUrl": "/blogs/tango-salesforce-park-2025-08-17.html",
    "blogTitle": "Free Tango class at Salesforce Park",
    "type": "pattern"
  },
  "Vecher Tango": {
    "blogUrl": "/blogs/tango-vecher-2025-08-30.html",
    "blogTitle": "Vecher Tango",
    "type": "pattern"
  },
  "[Oakland] SwingOut House Party!": {
    "blogUrl": "/blogs/wcs-veterans-memorial-oakland-2026-03-21.html",
    "blogTitle": "[Oakland] SwingOut House Party!",
    "type": "pattern"
  },
  "OmniZouk: Practica + Weekly Social": {
    "blogUrl": "/blogs/zouk-omnimovement-oakland-2026-02-26.html",
    "blogTitle": "OmniZouk: Practica + Weekly Social",
    "type": "pattern"
  }
};

export const getBlogForEvent = (eventName) => {
  // First try exact match
  if (BLOG_MAPPING[eventName] && BLOG_MAPPING[eventName].type === 'exact') {
    return BLOG_MAPPING[eventName];
  }
  
  // Then try pattern matching
  for (const [pattern, blogInfo] of Object.entries(BLOG_MAPPING)) {
    if (blogInfo.type === 'pattern' && eventName.includes(pattern)) {
      return blogInfo;
    }
  }
  
  return null;
};
export const getEventsWithBlogs = () => Object.keys(BLOG_MAPPING);
export default BLOG_MAPPING;
